export default __webpack_public_path__ + "static/media/spin-bg-12.9d0347dd.png";